
import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import './index.css';
import { api } from '../../services/api.js';
import Loading from "../../comum/Layout/loading.jsx";
import CardLista from "./cardlista.jsx";

import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import SweetAlert from 'react-bootstrap-sweetalert';

function ParceriaCPF() {
  const [removeLoading,   setRemoveLoading] = useState(false);
  const { codigo } = useParams();
  const [parceiros,       setParceiros] = useState([]);
  const [par_nome,        setParNome] = useState('');
  const [erro,            setErro] = useState('');
  const [cadastrados,     setCadastrados] = useState(0);
  const [semcadastro,     setSemcadastro] = useState(0);
  const [totcupons,       setTotcupons] = useState(0);
  const [totcompras,      setTotcompras] = useState(0);
  const [totdescontos,    setTotdescontos] = useState(0);

  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '')

  const formatNumber = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  }

  
  function formatLeadingZero(text) {
    if (text.length === 10) {
      return `0${text}`;
    } else
      if (parseInt(text) < 100) {
        return `0${text}`;
      } else {
        return `${text}`;
      }
  }


  function formatarCPF(cpf) {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  useEffect(() => {
    setErro('');
    api.get('/parceria/' + codigo+'/vendas/resumo',)
      .then(response => {
        setParceiros(response.data);
        setParNome(response.data[0].par_nome);
        setCadastrados(response.data[0].cadastrados);
        setSemcadastro(response.data[0].semcadastro);
        setTotcupons(response.data[0].cuponst);
        setTotcompras(response.data[0].comprast);
        setTotdescontos(response.data[0].descontost);
        setRemoveLoading(true);

      })
      .catch(err => {
        setErro(err.response.data.erro);
      });

  }, []);




  function Limpar(x) {
    setParNome('');
  }


  return <div>
    <Menu modulo="" />
    {!removeLoading && <Loading />}

    <div className="container-fluid pagina-dados offset-lg-3 col-lg-6">
      <form className="form-control-sm">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-sm-6 col-6">
            <label className="form-label">Parceiro</label>
            <input type="text" value={par_nome} className="form-control fontmenor" id="exampleInputid" aria-describedby="emailHelp" disabled />
          </div>
          <div className="col-xl-3 col-lg-3 col-sm-3 col-3">
            <label className="form-label"><i className="fa fa-thumbs-up"></i> Aptos</label>
            <input type="text" value={cadastrados} className="form-control fontmenor texto_centro" id="exampleInputid" aria-describedby="emailHelp" disabled />
          </div>
          <div className="col-xl-3 col-lg-3 col-sm-3 col-3">
            <label className="form-label vermelho"><i className="fa fa-thumbs-down"></i> Inaptos</label>
            <input type="text" value={semcadastro} className="form-control fontmenor texto_centro " id="exampleInputerp" aria-describedby="emailHelp" disabled />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6 col-lg-6 col-sm-6 col-6">
            <label className="form-label">Cupons</label>
            <input type="text" value={totcupons} className="form-control fontmenor" id="exampleInputid" aria-describedby="emailHelp" disabled />
          </div>
          <div className="col-xl-3 col-lg-3 col-sm-3 col-3">
            <label className="form-label"><i className="fa fa-usd"></i> Valor Vendas</label>
            <input type="text" value={formatNumber(totcompras)} className="form-control fontmenor texto_centro" id="exampleInputid" aria-describedby="emailHelp" disabled />
          </div>
          <div className="col-xl-3 col-lg-3 col-sm-3 col-3">
            <label className="form-label vermelho"><i className="fa fa-money"></i> Valor Descontos</label>
            <input type="text" value={formatNumber(totdescontos)} className="form-control fontmenor texto_centro " id="exampleInputerp" aria-describedby="emailHelp" disabled />
          </div>
        </div>
      </form>
      <div >
            <label className="form-label preco"><i className="fa fa-info-circle"></i> Associados e vendas - Utilização dos últimos 30 dias</label>
      </div>
      {
        parceiros.map((tabela) => {
          return <div className="col-lg-12 col-md-12 col-sm-12 col-12"
            key={tabela.par_cpf}>

            <CardLista
              id={tabela.par_cpf}
              cpf={formatarCPF(formatLeadingZero(formatLeadingZero(tabela.par_cpf)))}
              nome={tabela.fantasia}
              bairro={tabela.bairro}
              cidade={tabela.cidade}
              inclusao={tabela.dtahorainclusao}
              cupons={tabela.cupons}
              compras={formatNumber(tabela.compras)}
              descontos={formatNumber(tabela.descontos)}
              valor={formatNumber(tabela.valor)}
              statusfunc={tabela.seqpessoa < 1 ? "I" : tabela.statusfunc}
              cor={tabela.seqpessoa < 1 || tabela.statusfunc==="I" ? '#66666633' : null}
              
            />
            <p></p>
          </div>;
        })
      }
      <p></p>

      {removeLoading && <Footer className="footer navbar-fixed-bottom" />}
    </div>

    {
      erro != '' ?
        <SweetAlert
          danger
          showCloseButton
          confirmBtnText="OK"
          confirmBtnBsStyle="danger"
          onConfirm={() => setErro('')}
          title="Falha"
          reverseButtons={false}
          openAnim={{ name: 'showSweetAlert', duration: 2000 }}
          closeAnim={{ name: 'hideSweetAlert', duration: 100 }}
        >   {erro}
        </SweetAlert> : null
    }

    
  </div>
  

}

export default ParceriaCPF;